const CUSTOM = 0;
const SIDE = 1;

export default { CUSTOM, SIDE };
